export const NOTIFICATION_TYPES = {
	ERROR: 'error',
	WARN: 'warning',
	INFO: 'info',
	SUCCESS: 'success',
};

export const SET_NOTIFICATION = 'generalNotification/SET_NOTIFICATION';
export const CLOSE_NOTIFICATION = 'generalNotification/CLOSE_NOTIFICATION';
